module.exports = __webpack_public_path__ + "static/media/goal.a4be1337.jpg";